export enum ColorVariables {
  ACCENT_TEXT_COLOR = 'var(--accent_text_color)',
  BG_ALPHA_COLOR = 'var(--bg_alpha_color)',
  BG_COLOR = 'var(--bg_color)',
  BG_HEADER_BLUR = 'var(--bg_header_blur)',
  BUTTON_COLOR = 'var(--button_color)',
  BUTTON_TEXT_COLOR = 'var(--button_text_color)',
  COLOR_BLUE = 'var(--color_blue)',
  COLOR_BLUE_ALPHA = 'var(--color_blue_alpha)',
  COLOR_DARK_ORANGE = 'var(--color_dark_orange)',
  COLOR_GOLD = 'var(--color_gold)',
  COLOR_GREEN = 'var(--color_green)',
  COLOR_GREEN_ALPHA = 'var(--color_green_alpha)',
  COLOR_GREEN_GRASS = 'var(--color_green_grass)',
  COLOR_LIGHT_BLUE = 'var(--color_light_blue)',
  COLOR_MINT = 'var(--color_mint)',
  COLOR_ORANGE = 'var(--color_orange)',
  COLOR_ORANGE_ALPHA = 'var(--color_orange_alpha)',
  COLOR_PINK = 'var(--color_pink)',
  COLOR_PINK_ALPHA = 'var(--color_pink_alpha)',
  COLOR_PINK_LIGHT = 'var(--color_pink_light)',
  COLOR_RED_ALPHA = 'var(--color_red_alpha)',
  COLOR_VIOLET = 'var(--color_violet)',
  COLOR_VIOLET_ALPHA = 'var(--color_violet_alpha)',
  COLOR_YELLOW = 'var(--color_yellow)',
  DESTRUCTIVE_TEXT_COLOR = 'var(--destructive_text_color)',
  HEADER_BG_COLOR = 'var(--header_bg_color)',
  HINT_COLOR = 'var(--hint_color)',
  LINK_COLOR = 'var(--link_color)',
  QUARTERNARY_FILL_BACKGROUND = 'var(--quarternary_fill_background)',
  SECONDARY_BG_COLOR = 'var(--secondary_bg_color)',
  SECONDARY_FILL_COLOR = 'var(--secondary_fill_color)',
  SECONDARY_TEXT_COLOR = 'var(--secondary_text_color)',
  SECTION_BG_COLOR = 'var(--section_bg_color)',
  SECTION_HEADER_TEXT_COLOR = 'var(--section_header_text_color)',
  STROKE_ALPHA16 = 'var(--stroke_alpha16)',
  STROKE_ALPHA36 = 'var(--stroke_alpha36)',
  STROKE_IMG_ALPHA = 'var(--stroke_img_alpha)',
  SUBTITLE_TEXT_COLOR = 'var(--subtitle_text_color)',
  TERTIARY_BG_COLOR = 'var(--tertiary_bg_color)',
  TERTIARY_FILL_BACKGROUND = 'var(--tertiary_fill_background)',
  TERTIARY_FILL_COLOR = 'var(--tertiary_fill_color)',
  TERTIARY_TEXT_COLOR = 'var(--tertiary_text_color)',
  TEXT_COLOR = 'var(--text_color)',
  TEXT_WHITE_ALPHA = 'var(--text_white_alpha)',
}

export enum GradientVariables {
  GRADIENT_BRAND_1 = 'var(--gradient_brand_1)',
  GRADIENT_BRAND_10 = 'var(--gradient_brand_10)',
  GRADIENT_BRAND_11 = 'var(--gradient_brand_11)',
  GRADIENT_BRAND_12 = 'var(--gradient_brand_12)',
  GRADIENT_BRAND_13 = 'var(--gradient_brand_13)',
  GRADIENT_BRAND_2 = 'var(--gradient_brand_2)',
  GRADIENT_BRAND_3 = 'var(--gradient_brand_3)',
  GRADIENT_BRAND_4 = 'var(--gradient_brand_4)',
  GRADIENT_BRAND_5 = 'var(--gradient_brand_5)',
  GRADIENT_BRAND_6 = 'var(--gradient_brand_6)',
  GRADIENT_BRAND_7 = 'var(--gradient_brand_7)',
  GRADIENT_BRAND_8 = 'var(--gradient_brand_8)',
  GRADIENT_BRAND_9 = 'var(--gradient_brand_9)',
  GRADIENT_DEFAULT = 'var(--gradient_default)',
  GRADIENT_GREETING = 'var(--gradient_greeting)',
  GRADIENT_PLAYCOIN = 'var(--gradient_playcoin)',
  GRADIENT_STROKE = 'var(--gradient_stroke)',
  GRADIENT_TG_PREMIUM = 'var(--gradient_tg_premium)',
}
